import { useEffect, useRef, InputHTMLAttributes } from 'react';

import { useField } from '@unform/core';

import { Input } from './styles';

interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  value?: string;
}

const InputRadio: React.FC<FieldProps> = ({ name, value, ...rest }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { fieldName, registerField, defaultValue, error } = useField(name);

  useEffect(() => {
    registerField({ name: fieldName, ref: inputRef.current, path: 'value' });
  }, [fieldName, registerField]);

  return (
    <Input
      ref={inputRef}
      type="radio"
      value={value}
      defaultValue={defaultValue}
      error={!!error}
      {...rest}
    />
  );
};

export default InputRadio;
